export async function copyTextToClipboard(text) {
  if (!text) return false;

  if (globalThis.navigator?.clipboard?.writeText) {
    await globalThis.navigator.clipboard.writeText(text);
    return true;
  }

  return false;
}
